import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import OrderForm from '../../components/OrderForm';
import { formatCurrency, formatDate, ORDER_STATUS_COLORS, ORDER_STATUS_LABELS } from '../../utils/roles';

const WaiterPage = () => {
  const [activeTab, setActiveTab] = useState('new');
  const [myOrders, setMyOrders] = useState([]);

  useEffect(() => {
    fetchMyOrders();
  }, []);

  const fetchMyOrders = () => {
    api.get('/orders').then(res => {
      setMyOrders(res.data.data?.data || []);
    }).catch(() => {});
  };

  return (
    <div>
      <h1 style={{ color: '#e2e8f0', marginBottom: 24, fontSize: 28 }}>📝 Toma de Pedidos</h1>

      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {[{ key: 'new', label: 'Nuevo Pedido', icon: '📝' }, { key: 'history', label: 'Mis Pedidos', icon: '📋' }].map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '12px 24px', borderRadius: 10, border: 'none',
              background: activeTab === tab.key ? '#38bdf8' : '#1e293b',
              color: activeTab === tab.key ? '#0f172a' : '#94a3b8',
              fontWeight: 600, cursor: 'pointer', fontSize: 14,
            }}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'new' ? (
        <OrderForm onOrderCreated={fetchMyOrders} />
      ) : (
        <div>
          <h2 style={{ color: '#e2e8f0', marginBottom: 20 }}>📋 Mis Pedidos</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {myOrders.map(order => (
              <div key={order.id} className="card animate-fade-in">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div>
                    <span style={{ color: '#38bdf8', fontWeight: 700, fontSize: 16 }}>{order.order_number}</span>
                    <span style={{ color: '#64748b', marginLeft: 12, fontSize: 13 }}>{formatDate(order.created_at)}</span>
                  </div>
                  <span style={{
                    padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                    background: ORDER_STATUS_COLORS[order.status] + '20',
                    color: ORDER_STATUS_COLORS[order.status],
                  }}>
                    {ORDER_STATUS_LABELS[order.status]}
                  </span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#94a3b8', fontSize: 14 }}>
                    {order.items?.length || 0} items · {order.order_type === 'dine_in' ? '🪑 Mesa' : '📦 ' + order.order_type}
                  </span>
                  <span style={{ color: '#fbbf24', fontWeight: 700, fontSize: 16 }}>{formatCurrency(order.total)}</span>
                </div>
              </div>
            ))}
            {myOrders.length === 0 && (
              <p style={{ color: '#64748b', textAlign: 'center', padding: 40 }}>No tienes pedidos registrados</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default WaiterPage;